import { Crown } from 'lucide-react';

interface GameLogoProps {
  compact?: boolean;
  className?: string;
}

/** Teen Patti card-stack logo — shared by lobby and in-game header. */
export default function GameLogo({ compact = false, className = '' }: GameLogoProps) {
  return (
    <div
      className={[
        'provider-logo flex shrink-0 items-end gap-2',
        compact ? 'provider-logo-compact' : 'gap-3',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden
    >
      <div className={`provider-logo-cards ${compact ? 'provider-logo-cards-compact' : ''}`}>
        <div className="provider-logo-card provider-logo-card-1">
          A<span className="text-[7px]">♠</span>
        </div>
        <div className="provider-logo-card provider-logo-card-2">
          K<span className="text-[7px]">♦</span>
        </div>
        <div className="provider-logo-card provider-logo-card-3">
          Q<span className="text-[7px] text-red-600">♥</span>
        </div>
        <Crown size={compact ? 11 : 14} className="provider-logo-crown text-tp-gold" fill="currentColor" />
      </div>
      {!compact && (
        <div>
          <p className="provider-logo-title">TEEN PATTI</p>
          <p className="provider-logo-provider">PROVIDER</p>
        </div>
      )}
    </div>
  );
}
